import { isCreating, getEntity } from './_utils'

export const getFollowup = (state, { id }) => getEntity('followups')(state, { id })
export const creatingFollowup = isCreating('/api/followups')
